import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import useWizardComplete from 'Views/Page/Hooks/useWizardComplete';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import Layout from './Layout';

const styles = () => ({
  root: {
    paddingBottom: 0,
    paddingTop: 0,
    flexGrow: 1,
  },
});
const InvestmentProfileCompleteTemplate = ({
  className,
  classes,
  resource,
}) => {
  const history = useHistory();
  const handleComplete = useCallback(() => {
    history.push('/');
  }, []);
  const { handleNext } = useWizardComplete(handleComplete);
  const { loadPageContentLink } = usePageContentContext();
  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');
  const onPrevious = previousLink ? () => loadPageContentLink(previousLink) : undefined;

  return (
    <MetaFormInline
      className={classNames(className, classes.root)}
      noIndividualSubmitButtons
      resource={resource}
      layout={Layout}
      LayoutProps={{
        onNext: handleNext,
        onPrevious,
        hideErrorList: true,
      }}
    />
  );
};

InvestmentProfileCompleteTemplate.defaultProps = {
  className: '',
};

InvestmentProfileCompleteTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(InvestmentProfileCompleteTemplate);
